<template>
  <div class="user-login">
    <img
      :src="cdnresources + '/prod/upload/image/2021-11-30/6c640e94-4122-4db3-a4c3-b950b1edf959.png'"
      class="user-banner"
      alt="banner图"
    />
    <div class="content">
      <!-- <van-field
        class="field-input"
        label="姓名"
        placeholder="请输入姓名"
        v-model.trim="bindForm.userName"
        @blur="checkUserName"
        maxlength="30"
        :error-message="errMsg.userName"
        clearable
      /> -->
      <!--
        <van-field class="field-input" label="证件类型" placeholder="请选择证件类型" :value="bindForm.idName" readonly @click="changeCardType">
          <div slot="input">{{bindForm.idName}}
            <van-icon name="play" :class="['iconStyle', {'iconRote':typeShow}]" />
          </div>
        </van-field>
      -->
      <!-- <van-field
        class="field-input"
        ref="cardType"
        label="证件号码"
        placeholder="请输入证件号码"
        v-model.trim="bindForm.cardCode"
        @blur="checkCardCode"
        :error-message="errMsg.cardCode"
        clearable
        maxlength="30"
      /> -->
      <van-field
        class="field-input"
        label="手机号"
        placeholder="请输入购买预留的手机号"
        v-model.trim="bindForm.mobilePhone"
        @blur="checkPhone"
        :error-message="errMsg.mobilePhone"
        clearable
      />
      <van-field
        class="field-input field-sms"
        label="短信验证码"
        placeholder="请输入验证码"
        size="large"
        maxlength="6"
        v-model.trim="bindForm.captcha"
        clearable
        :error-message="errMsg.captcha"
        @blur="checkVeriCode"
        style="padding-right:0;"
      >
        <van-button
          slot="button"
          class="code-btn"
          size="small"
          :class="{ 'disable-btn': isDisable }"
          type="info"
          @click.prevent="sendVeriCode"
        >{{ captchaText }}</van-button>
      </van-field>
    </div>
    <van-button
      :class="['btn', 'common-btn', !isBothValue ? 'noactive' : 'canActive']"
      :disabled="!isBothValue"
      @click="register"
    >绑定/登录</van-button>
    <div class="agree">
      <img
        :src="nocheckVal"
        class="checkIcon"
        @click="changeCheck"
      />
      <span class="agree-txt">我已同意</span>
      <span
        class="txt"
        @click="handleShowAgreement(item)"
        v-for="(item, index) in agreementList"
        :key="index"
      >{{ item.text }}</span>
    </div>

    <!-- 证件类型 -->
    <van-popup
      v-model="typeShow"
      position="bottom"
    >
      <van-picker
        title="证件类型"
        show-toolbar
        :columns="CertifyTypeColumns"
        @confirm="selectCardType"
        @cancel="typeShow = false"
      />
    </van-popup>

    <!-- 用户协议 隐私声明 -->
    <pdf-action-sheet
      v-model="showAgreement"
      :style-obj="{ height: '70%' }"
      :title="agreementTitle"
    >
      <RegisterProtocol v-if="agreementType == 'register'" />
      <PrivacyStatement v-if="agreementType == 'privacy'" />
    </pdf-action-sheet>

    <!-- 图形验证码 -->
    <ImgValidator
      v-model="showImgValitor"
      :img="imgValidatorCode"
      @close="handleCloseImgValidator"
      @sure="handleStartValidatorNumber"
      @sendImgCode="handleSendImgCode"
    />
  </div>
</template>
<script>
import bdcg from '@/assets/img/user_center/bdcg.png'
import nocheck from '@/assets/img/user_center/nocheck.png'
import checkedIcon from '@/assets/img/user_center/checked.png'
import { CHECK_MOBILE_PHONE, CHECK_ID } from '@/util/validate'
import { SetGetAuthInfo } from '@/util/auth'
import { CertifyTypeColumns } from '@/util/enum-data'
import { getDeviceInfo } from '@/util/tools'
import { cdnresources } from '@/util/config'
import {
  GetVerificationCode,
  WechatUserBindPhone,
  GetImageVerifyCode
} from '@/api/user'
import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
import PrivacyStatement from '@/views/UserSection/PrivacyStatement.vue'
import RegisterProtocol from '@/views/UserSection/RegisterProtocol.vue'
import ImgValidator from '@/components/ImgValidator.vue'
export default {
  name: 'UserLogin',
  components: {
    PdfActionSheet,
    RegisterProtocol,
    PrivacyStatement,
    ImgValidator
  },
  data () {
    return {
      cdnresources,
      bdcg,
      nocheck,
      checkedIcon,
      nocheckVal: nocheck,
      checked: false,
      typeShow: false, // 控制 身份证类型 pop
      CertifyTypeColumns,
      bindForm: {
        userName: '',
        idName: '身份证',
        cardType: 'identityCard',
        cardCode: '',
        mobilePhone: '',
        captcha: ''
      },
      errMsg: {
        userName: '',
        cardCode: '',
        mobilePhone: '',
        captcha: ''
      },
      isDisable: false,
      captchaText: '获取验证码',
      cookieUser: {},
      DeviceInfo: {}, // 环境信息
      agreementList: [
        {
          code: 'register',
          text: '《用户协议》'
        },
        {
          code: 'privacy',
          text: '《隐私声明》'
        }
      ],
      showAgreement: false,
      agreementTitle: '',
      agreementType: '',

      // 图形验证码
      imgValidatorCode: '',
      showImgValitor: false, // 控制 图形验证码显示
      haveImgValidator: process.env.VUE_APP_START_IMG_VALIDATOR // 总开关 值为 true 才去触发图形验证码
    }
  },
  computed: {
    isBothValue () {
      const {
        //userName,
        cardType,
        // cardCode,
        mobilePhone,
        captcha
      } = this.bindForm
      if ( cardType && mobilePhone && captcha) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // 检测到 有用户信息 则 跳转到 UserCenter 页面
    this.cookieUser = SetGetAuthInfo.getInfo()
    this.DeviceInfo = getDeviceInfo()

    if (this.cookieUser.userId) {
      this.jumpUserCenter()
    }
  },
  methods: {
    // 关闭图形验证码
    handleCloseImgValidator (value) {
      this.showImgValitor = value
    },
    // 如果 图形验证码正确则执行 开启倒计时
    handleStartValidatorNumber (obj) {
      if (obj.code) {
        this.confirmsf(obj.code)
      }
    },
    // 发送验证码前 进行校验
    async sendVeriCode () {
      if (!this.bindForm.mobilePhone) {
        this.$notify({
          color: '#F4111F',
          background: '#FFEC70',
          message: '请填写手机号'
        })
        return
      }
      if (!CHECK_MOBILE_PHONE(this.bindForm.mobilePhone)) {
        this.$notify({
          color: '#F4111F',
          background: '#FFEC70',
          message: '手机号格式不正确'
        })
        return
      }
      if (this.isDisable) {
        return
      }
      this.confirmsf()
      // if (this.haveImgValidator == 'true') {
      // this.showImgValitor = true
      // this.getImgValidator()
      // } else {
      //   this.confirmsf()
      // }
    },
    // 重新获取 图形验证码
    handleSendImgCode () {
      this.getImgValidator()
    },
    // 发送图形验证码
    async getImgValidator () {
      try {
        if (!this.bindForm.mobilePhone) {
          this.$notify({
            color: '#F4111F',
            background: '#FFEC70',
            message: '请填写手机号'
          })
        }
        const res = await GetImageVerifyCode({
          mobilePhone: this.bindForm.mobilePhone
        })
        this.imgValidatorCode = res
      } catch (e) {
        this.$notify({
          color: '#F4111F',
          background: '#FFEC70',
          message: e.message
        })
      }
    },
    // 发送验证码
    async confirmsf (beforeCaptcha) {
      try {
        const params = { mobilePhone: this.bindForm.mobilePhone }
        // if (this.haveImgValidator == 'false') {
        //   params.graphicalSwitch = '1'
        // }
        if (beforeCaptcha) {
          Object.assign(params, { beforeCaptcha })
        }
        await GetVerificationCode(params)
        //  验证成功 隐藏 图片验证码 弹框
        this.showImgValitor = false
        this.captchaText = '获取中...'
        this.isDisable = true
        let countDown = 60
        this.captchaText = `${countDown}s`
        this.veriInterval = setInterval(() => {
          countDown = countDown - 1
          if (countDown === 0) {
            clearInterval(this.veriInterval)
            this.isDisable = false
            this.captchaText = `获取验证码`
          } else {
            this.captchaText = `${countDown}s`
          }
        }, 1000)
      } catch (e) {
        this.$notify({
          color: '#F4111F',
          background: '#FFEC70',
          message: e.message
        })
      }
    },
    // 打开 证件类型 pop
    changeCardType () {
      this.typeShow = true
    },
    // 勾选协议操作
    changeCheck () {
      this.checked = !this.checked
      if (!this.checked) {
        this.nocheckVal = this.nocheck
      } else {
        this.nocheckVal = this.checkedIcon
      }
    },
    // 跳到个人中心
    jumpUserCenter () {
      const { fromSourceCode } = this.$route.query // 灵锡的登录 是需要配置 fromSourceCode 的
      if (fromSourceCode) {
        localStorage.setItem('fromSourceCode', fromSourceCode)
      }
      this.$router.push({
        name: 'UserCenter'
      })
    },
    // 选择证件类型
    selectCardType (e) {
      this.bindForm.idName = e.text
      this.bindForm.cardType = e.type
      this.typeShow = false
      this.bindForm.cardCode = ''
      this.errMsg.cardCode = ''
    },
    // 检测姓名
    checkUserName () {
      if (!this.bindForm.userName) {
        this.errMsg.userName = '请输入姓名！'
        return false
      } else {
        this.errMsg.userName = ''
        return true
      }
    },
    // 检测身份证
    checkCardCode () {
      const { cardCode } = this.bindForm
      if (!cardCode) {
        this.errMsg.cardCode = '请输入证件号码！'
        return false
      } else if (!CHECK_ID(cardCode) && this.bindForm.idName === '身份证') {
        // todo 各种卡的校验
        this.errMsg.cardCode = '身份证格式不正确！'
        return false
      } else {
        this.errMsg.cardCode = ''
        return true
      }
    },
    // 检测手机号
    checkPhone () {
      if (!this.bindForm.mobilePhone) {
        this.errMsg.mobilePhone = '请输入购买预留的手机号！'
        return false
      } else if (!CHECK_MOBILE_PHONE(this.bindForm.mobilePhone)) {
        this.errMsg.mobilePhone = '手机号格式不正确！'
        return false
      } else {
        this.errMsg.mobilePhone = ''
        return true
      }
    },
    // 检测验证码
    checkVeriCode () {
      if (!this.bindForm.captcha) {
        this.errMsg.captcha = '请输入验证码！'
        return false
      }
      this.errMsg.captcha = ''
      return true
    },
    // 检测勾选协议
    checkAgree () {
      if (!this.checked) {
        this.$notify({
          color: '#F4111F',
          background: '#FFEC70',
          message: '请勾选协议！'
        })
        return false
      } else {
        return true
      }
    },
    // 绑定/登录操作
    async register () {
      // userType：lxApp、H5、wechatUser（默认）
      let userType = 'wechatUser'
      const { fromSourceCode } = this.$route.query
      if (
        fromSourceCode == process.env.VUE_APP_LX_FROM_CODE ||
        fromSourceCode == process.env.VUE_APP_LXGZH_FROM_CODE
      ) {
        userType = 'lxApp'
      } else {
        if (this.DeviceInfo.env === 'wechat') {
          userType = 'wechatUser'
        } else {
          userType = 'H5'
        }
      }

      if (
        //this.checkUserName() &&
        this.checkPhone() &&
        this.checkVeriCode() &&
        this.checkAgree()
      ) {
        const {
          userName,
          // cardType,
          // cardCode,
          mobilePhone,
          captcha
        } = this.bindForm
        try {
          const res = await WechatUserBindPhone(
            {
              userName,
              // cardType,
              // cardCode,
              mobilePhone,
              captcha,
              userType,
              openId: this.$store.state.userInfo.openId || ''
            },
            {
              isShow: true,
              text: '提交中...'
            }
          )
          this.$toast({
            message: '绑定成功',
            icon: bdcg,
            duration: 2000
          })
          SetGetAuthInfo.setInfo(res)
          this.$store.commit('SET_USER_INFO', res)
          let timers = setInterval(() => {
            this.jumpUserCenter()
            clearInterval(timers)
          }, 2000)
        } catch (e) {
          this.$notify({
            color: '#F4111F',
            background: '#FFEC70',
            message: e.message
          })
        }
      }
    },
    // 跳到 「用户协议」
    handleShowAgreement (item) {
      this.showAgreement = true
      this.agreementTitle = item.text
      this.agreementType = item.code
    }
  }
}
</script>

<style scoped lang="scss">
.iconRote {
  transform: rotate(-90deg) !important;
}
.iconStyle {
  transform: rotate(90deg);
  font-size: 8px;
  margin-left: 6px;
}
.checkIcon {
  display: inline-block;
  height: 15px;
  width: 15px;
}
.user-login {
  .user-banner {
    width: 100%;
    display: block;
  }

  .content {
    background-color: #fff;
    box-shadow: 0px 0px 5px 0px rgba(106, 0, 0, 0.14);
    border-radius: 10px;
    padding: 30px 15px;
    width: 343px;
    margin: 0 auto;
    position: relative;
    top: -20px;

    /deep/ .van-field__label {
      width: 90px;
      font-size: 14px;
    }

    .title {
      color: #1c1c1c;
      margin-bottom: 15px;
      font-size: 18px;
    }

    .field-input {
      font-size: 15px;
      color: #272727;
      border-bottom: 1px solid #f1f3f8;
      padding-left: 5px;
      padding-right: 5px;

      /deep/ input {
        color: #272727;
      }
    }
    .field-sms {
      align-items: center;
    }

    .code-btn {
      background: #fff;
      color: #387dff;
      outline: none;
      border: 1px solid #387dff;
      border-radius: 16px;
      // padding: 0 16px;
      width: 90px;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .disable-btn {
    background: #aaa;
    color: #fff;
    border: 1px solid transparent;
  }
  .agree {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    text-align: justify;

    .agree-txt {
      margin-left: 5px;
    }
    .txt {
      color: #31a9ff;
    }
  }
}
/deep/ .pop-content p {
  font-size: 12px;
}
/deep/ .van-field__control {
  font-size: 14px;
}
</style>
